import Config from './config'

const Log = (message?: any, ...optionalParams: any[]): void => {
  if (Config.enableLog) console.log(message, ...optionalParams)
}

export default Log
